module.exports = __webpack_public_path__ + "img/pin-triplo-diamante.37b2102d.png";